import React from "react";
import PropTypes from "prop-types";
import Contain from "~components/atoms/contain/contain";
import HorizontalDivider from "~components/molecules/horizontal_divider/horizontal_divider";
import { LINK } from "../../../prop_types";
import { buttonWrapperStyle } from "./chapter_prev_next_buttons.module.scss";
import PrevNextButton from "./components/prev_next_button/prev_next_button";

function ChapterPrevNextButtons({
  previous,
  previousTitle,
  previousDescription,
  next,
  nextTitle,
  nextDescription,
}) {
  if (
    (previous && previousTitle && previousDescription) ||
    (next && nextTitle && nextDescription)
  ) {
    return (
      <Contain>
        <HorizontalDivider />
        <div
          className={buttonWrapperStyle}
          data-testid="chapter-prev-next-buttons"
        >
          <PrevNextButton
            type="Previous"
            link={previous?.link}
            title={previousTitle}
            description={previousDescription}
          />

          <PrevNextButton
            type="Next"
            link={next?.link}
            title={nextTitle}
            description={nextDescription}
          />
        </div>
      </Contain>
    );
  }
  return null;
}

ChapterPrevNextButtons.propTypes = {
  previous: PropTypes.shape({
    link: LINK,
  }),
  next: PropTypes.shape({
    link: LINK,
  }),
  previousDescription: PropTypes.string,
  previousTitle: PropTypes.string,
  nextDescription: PropTypes.string,
  nextTitle: PropTypes.string,
};

ChapterPrevNextButtons.defaultProps = {
  previous: null,
  next: null,
  previousDescription: "",
  previousTitle: "",
  nextDescription: "",
  nextTitle: "",
};

export default ChapterPrevNextButtons;
